<template>
  <div class="hero-banner">
    <div class="hero-banner-container">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="hero-banner-title">
              <h1>{{title}}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
};
</script>

<style lang="scss" scoped>
.hero-banner {
  position: relative;
  background-color: #000;
  color: #fff;
  overflow: hidden;
  height: 45vh;
}

.hero-banner-container {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 30px 0;
  z-index: 999;
  transform: translate(0%, -70%);
}

.hero-banner:before {
  position: absolute;
  top: 0;
  right: 0;
  content: "";
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.hero-banner:after {
  position: absolute;
  zoom: 1.2;
  top: -10%;
  right: -25%;
  content: url('~@theme/src/images/backdrop-logo.png');
  z-index: 9;
}

.hero-banner-title h1 {
  font-family: realistnarrow, sans-serif;
  font-size: 40px;
  font-weight: 900;
  line-height: 40px;
}
</style>
